<template>
  <div>
    <div class="row mb-3">
      <Period-Selector/>
      <Company-Selector/>
    </div>

    <div class="row">
      <div class="col-xl-3 col-md-6">
        <Affiliates-MiniCard/>
      </div> 

      <div class="col-xl-3 col-md-6">
        <Leads-Received-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Leads-Closed-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-MiniCard/>
      </div>
    </div>

    <Home-Tabs/>
    <!-- <router-view/> -->

  </div>
</template>

<script>
  import HomeTabs from './HomeTabs.vue'
export default {
  components: {
    HomeTabs
  },
  name: 'Home-Top',
  computed: {
    companySelected () {
      return this.$store.getters.companySelected
    }
  },
  watch: {
    // companySelected: function (val) {
    //   if (val === 0 && this.$route.path === '/admin/home/singleview') {
    //     this.$router.push('/admin/home/multiview')
    //   }
    //   else if (this.$route.path === '/admin/home/multiview') {
    //     this.$router.push('/admin/home/singleview')
    //   }
    // }
  }
}
</script>

<style>
</style>